module.exports = __webpack_public_path__ + "static/media/gameover_pic_d.69a479f4.png";